import React from 'react';
import { RichtextStoryblok } from '../../../_shared/interfaces/storyblok';
import { getRichTextMarkup, StoryblokCommon } from '../../../lib/storyblok/storyblok';

import * as RichtextStyles from '../../../_scss/modules/_richtext.module.scss';

const Richtext = ({ blok, storyblokCommon }: { blok: RichtextStoryblok; storyblokCommon: StoryblokCommon }) => {
    return (
        <div
            className={RichtextStyles.richtext}
            dangerouslySetInnerHTML={getRichTextMarkup(blok.richtext)}
            style={{ padding: blok.padding ? '0 80px' : undefined }}
        />
    );
};

export default Richtext;
